import { Component, OnInit } from '@angular/core';
import { WindowService } from '../../browser/window.service';
import { FlashService } from './flash.service';

@Component({
  selector: 'ls-flash',
  templateUrl: './flash.component.html',
  styleUrls: ['./flash.component.scss']
})
export class FlashComponent implements OnInit {
  public showFlash = false;
  public text = '';
  public flashClass: string;

  constructor(
    private flash: FlashService,
    private windowService: WindowService
  ) {}

  public ngOnInit(): void {
    this.flash.registerFlash(this);
  }

  public show(text: string, flashClass: string, scrollTo?: boolean): void {
    this.text = text;
    this.flashClass = flashClass;
    this.showFlash = true;
    if (scrollTo) {
      setTimeout(() => {
        this.windowService.scrollIntoView({
          selector: 'o-flash',
          byClass: true
        });
      });
    }
  }

  public hide(): void {
    this.showFlash = false;
  }
}
